import { gql } from '@apollo/client';

export const GENERATE_TICKET_NUMBER = gql`
mutation generateTicketNumber($input: GenerateTicketNumberInput!) {
  generateTicketNumber(input: $input) {
    clientMutationId
    errors
    ticket {
      id
      currentStatus
    }
    ticketNumber
    ticketUuid
  }
}
`

// inputs: ticketId: ID!
// officerId: ID!